import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  LayoutDashboard, Users, GraduationCap, BookOpen, ClipboardCheck,
  Calendar, DollarSign, Bell, Clock, BarChart2, MessageCircle,
  Library, LogOut, Settings, ChevronRight, School
} from 'lucide-react';

const NAV = [
  { section: 'Main', items: [
    { path: '/erp', label: 'Dashboard', icon: <LayoutDashboard size={17} />, roles: ['admin', 'teacher'] },
  ]},
  { section: 'Academics', items: [
    { path: '/erp/students', label: 'Students', icon: <GraduationCap size={17} />, roles: ['admin', 'teacher'] },
    { path: '/erp/teachers', label: 'Teachers', icon: <Users size={17} />, roles: ['admin'] },
    { path: '/erp/classes', label: 'Classes & Subjects', icon: <School size={17} />, roles: ['admin'] },
    { path: '/erp/timetable', label: 'Timetable', icon: <Clock size={17} />, roles: ['admin', 'teacher'] },
  ]},
  { section: 'Operations', items: [
    { path: '/erp/attendance', label: 'Attendance', icon: <ClipboardCheck size={17} />, roles: ['admin', 'teacher'] },
    { path: '/erp/exams', label: 'Exams & Results', icon: <BookOpen size={17} />, roles: ['admin', 'teacher'] },
    { path: '/erp/fees', label: 'Fees', icon: <DollarSign size={17} />, roles: ['admin'] },
    { path: '/erp/library', label: 'Library', icon: <Library size={17} />, roles: ['admin', 'teacher'] },
  ]},
  { section: 'Communication', items: [
    { path: '/erp/notices', label: 'Notices', icon: <Bell size={17} />, roles: ['admin', 'teacher'] },
    { path: '/erp/holidays', label: 'Holidays', icon: <Calendar size={17} />, roles: ['admin', 'teacher'] },
    { path: '/erp/whatsapp', label: 'WhatsApp', icon: <MessageCircle size={17} />, roles: ['admin', 'teacher'] },
  ]},
  { section: 'Reports', items: [
    { path: '/erp/reports', label: 'Reports', icon: <BarChart2 size={17} />, roles: ['admin', 'teacher'] },
  ]},
  { section: 'Admin', items: [
    { path: '/erp/settings', label: 'Settings', icon: <Settings size={17} />, roles: ['admin'] },
  ]},
];

export default function Sidebar({ open, onClose }) {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const go = (path) => { navigate(path); onClose?.(); };

  return (
    <aside className={`sidebar ${open ? 'open' : ''}`}>
      {/* Logo */}
      <div className="sidebar-logo">
        <div className="sidebar-logo-icon">
          <School size={20} color="#fff" />
        </div>
        <div>
          <div className="sidebar-logo-text">School ERP</div>
          <div className="sidebar-logo-sub">Management System</div>
        </div>
      </div>

      {/* Nav */}
      <nav className="sidebar-nav">
        {NAV.map(section => {
          const visible = section.items.filter(i => !i.roles || i.roles.includes(user?.role));
          if (!visible.length) return null;
          return (
            <div key={section.section}>
              <div className="sidebar-section">{section.section}</div>
              {visible.map(item => (
                <button
                  key={item.path}
                  className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
                  onClick={() => go(item.path)}
                >
                  {item.icon}
                  <span style={{ flex: 1 }}>{item.label}</span>
                  {location.pathname === item.path && <ChevronRight size={14} />}
                </button>
              ))}
            </div>
          );
        })}
      </nav>

      {/* Footer user */}
      <div className="sidebar-footer">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
          <div className="avatar" style={{ background: 'var(--primary)', color: '#fff', fontSize: '0.8rem' }}>
            {user?.full_name?.split(' ').map(w => w[0]).join('').slice(0,2).toUpperCase()}
          </div>
          <div style={{ flex: 1, overflow: 'hidden' }}>
            <div style={{ color: '#fff', fontSize: '0.85rem', fontWeight: 700, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{user?.full_name}</div>
            <div style={{ color: 'rgba(255,255,255,0.45)', fontSize: '0.72rem', textTransform: 'capitalize' }}>{user?.role}</div>
          </div>
        </div>
        <button className="nav-item" onClick={logout} style={{ color: '#ff6b6b' }}>
          <LogOut size={17} /> Logout
        </button>
      </div>
    </aside>
  );
}
